// Keep Cognito delivery/configuration errors distinct from an incorrect OTP.
export const recoveryErrorMessage = (code?: string): string => {
  switch (code) {
    case "CodeMismatchException":
      return "The confirmation code is incorrect. Please check it and try again."
    case "ExpiredCodeException":
      return "This code has expired. Please request a new code."
    case "InvalidPasswordException":
      return "The password does not meet the password requirements. Please choose a stronger password."
    case "LimitExceededException":
    case "TooManyRequestsException":
    case "TooManyFailedAttemptsException":
      return "Too many attempts. Please wait before trying again."
    case "CodeDeliveryFailureException":
    case "InvalidSmsRoleAccessPolicyException":
    case "InvalidSmsRoleTrustRelationshipException":
      return "The verification SMS could not be sent. Please contact support."
    case "UserNotConfirmedException":
      return "Your account is not confirmed. Please sign in to request an account verification code."
    case "UserNotFoundException":
    case "InvalidParameterException":
    case "NotAuthorizedException":
      return "Password reset is not available for this account. Check your mobile number or contact support."
    case "NetworkError":
      return "Unable to connect. Please check your connection and try again."
    default:
      return "Unable to complete this request. Please try again or contact support."
  }
}
